 
 <template>
  <div class="main" style="padding-right: 20px">
    <el-tabs type="border-card" style="margin-top: 50px" value="p">
      <el-tab-pane label="我的方案">
 <span slot="label">  我的方案   
         <el-badge class="mark" :value="m_p.total" />
        </span>
          
        <div class="sc-search-bar">
          <el-select
            placeholder="选择模块"
            clearable
            style="flex: 2"
            v-model="my_search.model"
          >
            <el-option
              v-for="(item, kk) in module_dict"
              :key="kk"
              :label="item"
              :value="kk"
            ></el-option>
          </el-select>
          <el-select
            clearable
            placeholder="选择类型"
            style="flex: 2"
            v-model="my_search.type"
          >
            <el-option
              v-for="(item, kk) in type_dict"
              :key="kk"
              :label="item"
              :value="kk"
            ></el-option>
          </el-select>
          <el-date-picker
            clearable
            style="flex: 2;display:none;"
            v-model="my_search.date_range"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <el-input
            placeholder="输入关键字搜索"
            style="flex: 3"
            v-model="my_search.key"
            clearable
          />

      
        </div>
        <el-table
          :data="m_scs"
          style="width: 100%"
        >
          <el-table-column label="名称">
            <template slot-scope="scope">
              <i class="el-icon-user"></i>
              <span style="margin-left: 10px">
                {{ module_label(scope.row.name) }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="模块">
            <template slot-scope="scope">
              <span> {{ module_label(scope.row.module) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <span> {{ type_label(scope.row.type) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建日期">
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">
                {{ dt_label(scope.row.creationTime) }}</span
              >
            </template>
          </el-table-column>
          <el-table-column align="right">
            <template slot="header" slot-scope="scope">
             
            </template>
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleShare(scope.$index, scope.row)"
                icon="el-icon-share"
                >分享</el-button
              >
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="handleDelete(scope.$index, scope.row, 'my')"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
          <div style="margin-top:20px;">  
  <el-pagination
    class="fy"
    layout="prev, pager, next"
    @current-change="m_p_change"
    :total="m_p.total"
    background
  >
  </el-pagination>
  </div>
      </el-tab-pane>
      <el-tab-pane name="p">
        <span slot="label"><i class="el-icon-date"></i> 共享的方案   
         <el-badge class="mark" :value="p_p.total" />
        </span>
           <div class="sc-search-bar">
          <el-select
            placeholder="选择模块"
            clearable
            style="flex: 2"
            v-model="p_search.model"
          >
            <el-option
              v-for="(item, kk) in module_dict"
              :key="kk"
              :label="item"
              :value="kk"
            ></el-option>
          </el-select>
          <el-select
            clearable
            placeholder="选择类型"
            style="flex: 2"
            v-model="p_search.type"
          >
            <el-option
              v-for="(item, kk) in type_dict"
              :key="kk"
              :label="item"
              :value="kk"
            ></el-option>
          </el-select>
          <el-date-picker  
            clearable
            style="flex: 2;display:none;"
            v-model="p_search.date_range"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <el-input
            placeholder="输入关键字搜索"
            style="flex: 3"
            v-model="p_search.key"
            clearable
          />

      
        </div>
        <el-table
          :data="p_scs"
          style="width: 100%"
        >
          <el-table-column label="名称">
            <template slot-scope="scope">
              <i class="el-icon-s-flag"></i>
              <span style="margin-left: 10px">
                {{ module_label(scope.row.name) }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="模块">
            <template slot-scope="scope">
              <span> {{ module_label(scope.row.module) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <span> {{ type_label(scope.row.type) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建日期">
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">
                {{ dt_label(scope.row.creationTime) }}</span
              >
            </template>
          </el-table-column>
          <el-table-column align="right">
           
            <template slot-scope="scope">
              <el-button
                size="mini"
                icon="el-icon-document-copy"
                @click="handleRef(scope.$index, scope.row)"
                >使用</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row, 'public')"
                icon="el-icon-delete"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top:20px;">  
        <el-pagination
          class="fy"
          layout="prev, pager, next"
          @current-change="p_p_change"
          :total="p_p.total"
          background
        >
        </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      :title="displayDialogTitle"
      :visible.sync="showShare"
      :center="false"
      :append-to-body="true"
    >
      <div style="padding: 30px">
        <el-form
          ref="form"
          :model="schemaEntry"
          label-width="120px"
          label-position="right"
        >
          <el-form-item label="方案名称"
            ><el-input v-model="schemaEntry.name"> </el-input
          ></el-form-item>
          <el-form-item label="模块">
            <el-select
              v-model="schemaEntry.module"
              placeholder="请选择结果集"
              @change="onSelectedSchemaChanged"
            >
              <el-option label="新搜索方案" value="0"> </el-option>
              <el-option
                v-for="(item, kk) in module_dict"
                :key="kk"
                :label="item"
                :value="kk"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="hideDialog">关闭</el-button>
        <el-button @click="confirmDialog" type="primary">{{
          actionDisplay
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      my_module: "",
      my_dr: "",
      my_search: {
        model: "",
        type: "",
        key: "",
        date_range: [],
      },
       p_search: {
        model: "",
        type: "",
        key: "",
        date_range: [],
      },
      p_p:{
        size:10,
        index:1,
        total:0,
      },
       m_p:{
        size:10,
        index:1,
        total:0,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      module_dict: {
        EquipAnalysis: "装备表",
        EquipModelCompare: "子车型对比",
        EquipGradientAnalysis: "装备梯度",
        EinbaurateAnalysis: "装车率",
        Timeline: "生命周期研究",
        EquipmentRateAnalysis: "装备率",
        SaleAnalysis: "子车型销量",
        LineSaleAnalysis: "车款销量",
        EquipSaleAnalysis: "装备销量",
        EquipPVA: "PVA",
        EquipCompare: "车款对比",
      },
      type_dict: { search: "搜索", result: "结果集" },
      search: "",
      myschema: [],
      schema_ls: [],
      showShare: false,
      schemaEntry: { id: "", name: "", module: "" },
      action: "share",
    };
  },
  methods: {
    ...mapMutations("commonsearch", ["setCurrentSearchSchema"]),
    ...mapActions("schema", [
      "get_my_schema_list",
      "get_schema_list",
      "delete_schema",
      "copy_schema",
      "to_public",
    ]),
    onMySearch() {
      alert(JSON.stringify(this.my_search));
    },
    onSelectedSchemaChanged() {},
    hideDialog() {
      this.showShare = false;
    },
     m_p_change(currentPage){
       this.m_p.index = currentPage;
    },
    p_p_change(currentPage){
       this.p_p.index = currentPage;
    },
    module_label(name) {
      if (name in this.module_dict) {
        return this.module_dict[name];
      }
      return name;
    },
    type_label(name) {
      if (name in this.type_dict) {
        return this.type_dict[name];
      }
      return name;
    },
    dt_label(dt) {
      let cur = dt.split("T")[0];
      if (cur == "0001-01-01") return "很久以前";
      return cur;
    },
    handleRef(index, row) {
      console.log(index, row);
      this.schemaEntry.id = row.id;
      this.schemaEntry.name = row.name;
      this.schemaEntry.module = row.module;
      this.action = "ref";
      this.showShare = true;
    },
    handleShare(index, row) {
      this.schemaEntry.id = row.id;
      this.schemaEntry.name = row.name;
      this.schemaEntry.module = row.module;
      this.action = "share";
      this.showShare = true;
    },
    handleDelete(index, row, w) {
      console.log(index, row);
      let self = this;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          // alert(row.id);
          self.delete_schema({ postData: { id: row.id } });
          if (w == "my") {
            self.myschema.splice(index, 1);
          } else {
            self.schema_ls.splice(index, 1);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
      this.queryMySchema();
      this.querySchemaList();
    },
    confirmDialog() {
      let it = this.schemaEntry;
      var postData = { name: it.name, id: it.id, module: it.module };
      if (this.action == "share") {
        this.to_public({ postData: postData });
        this.querySchemaList();
      } else {
        this.copy_schema({ postData: postData });
        this.queryMySchema();
      }
      this.showShare = false;
    },
    queryMySchema() {
      let self = this;
      var postData = { module: "", type: "" };
      this.get_my_schema_list({
        postData: postData,
        handle: function (res) {
          //alert(JSON.stringify(res));
          self.myschema = res;
          self.m_p.total = res.length;
        },
      });
    },
    querySchemaList() {
      let self = this;
      var postData2 = { userId: 0 };
      this.get_schema_list({
        postData: postData2,
        handle: function (res) {
          //alert(JSON.stringify(res));
          self.schema_ls = res;
          self.p_p.total = res.length;
        },
      });
    },
  },
  mounted() {
    this.queryMySchema();
    this.querySchemaList();
  },
  computed: {
    actionDisplay() {
      if (this.action == "share") {
        return "分享";
      } else {
        return "复制";
      }
    },
    displayDialogTitle() {
      if (this.action == "share") {
        return "分享我的方案";
      } else {
        return "复制到我的方案";
      }
    },
    p_scs(){
        let p_search = this.p_search;
        var dt = this.schema_ls.filter((data) =>!p_search.key ||data.name.includes(p_search.key))
        .filter((data)=> !p_search.model || data.module == p_search.model )
        .filter((data)=> !p_search.type || data.type == p_search.type )
        this.p_p.total = dt.length;
        let p_p = this.p_p;
        let  data =  dt.slice((p_p.index-1)*p_p.size,p_p.index*p_p.size);
        return data;
    },
     m_scs(){
        let my_search = this.my_search;
        var dt = this.myschema.filter((data) =>!my_search.key ||data.name.includes(my_search.key))
        .filter((data)=> !my_search.model || data.module == my_search.model )
        .filter((data)=> !my_search.type || data.type == my_search.type )
        this.m_p.total = dt.length;
        let m_p = this.m_p;
        let  data =  dt.slice((m_p.index-1)*m_p.size,m_p.index*m_p.size);
        return data;
    }
  },
  watch:{
    p_scs(newValue)
    {
      //this.p_p.size = newValue.length;
    }
  }
};
</script>

<style type="scoped">
.sc-search-bar {
  display: flex;
  position: static;
  left: 200px;
  height: 50px;
}
.sc-search-bar > div,
.sc-search-bar > button {
  margin: auto 5px;
 
}
</style>